import Store from '@/store/index.js'

const Layout = () => import('@/pages/Onboarding/Layout/index.vue')
const TermsAndConditionsPage = () =>
  import('@/pages/Wkis/TermsAndConditions/index.vue')
const InvitationPage = () => import('@/pages/Wkis/InvitationPage/index.vue')
const LicenseErrorPage = () => import('@/pages/Wkis/LicenseError/index.vue')

export default [
  {
    path: '/privacy-policy',
    component: Layout,
    meta: {
      layout: 'onboarding-layout',
    },
    children: [
      {
        path: '',
        name: 'wkis-terms-and-conditions',
        component: TermsAndConditionsPage,
      },
    ],
    beforeEnter: (_to, _from, next) => {
      if (Store.getters['wkis/shouldUserRedirectToTermsAndConditions']) {
        next()
      } else {
        next({ name: 'home', replace: true })
      }
    },
  },
  {
    path: '/invitations',
    component: Layout,

    children: [
      {
        path: '',
        name: 'wkis-invitations-page',
        component: InvitationPage,

        beforeEnter: (_to, _from, next) => {
          if (Store.getters['wkis/shouldUserRedirectToInvitations']) {
            next()
          } else {
            next({ name: 'home', replace: true })
          }
        },
      },
    ],
  },

  {
    path: '/license-error',
    component: Layout,
    meta: {
      layout: 'onboarding-layout',
      unauthorized: true,
    },
    children: [
      {
        path: '',
        name: 'license-error-page',
        component: LicenseErrorPage,
      },
    ],
  },
]
